module.exports = __webpack_public_path__ + "img/fist.87bac40b.png";